module.exports = __webpack_public_path__ + "zl3-2fc8cd1c.png";